import React, { memo } from 'react';

import IconButton from '@mui/material/IconButton';
import TooltipForButton from '@/components/mui/Tooltip/TooltipForButton';

import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';

type ExportButtonProps = {
  onClick: () => void;
};

const ExportButton = ({ onClick }: ExportButtonProps) => (
  <TooltipForButton
    t={{
      id: 'tooltip.export',
      defaultMessage: 'Export',
    }}
  >
    <IconButton color="primary" onClick={onClick}>
      <FileDownloadOutlinedIcon />
    </IconButton>
  </TooltipForButton>
);

export default memo(ExportButton);
